import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AlertService } from '../services/alert/alert.service';
import { LoadingService } from '../services/loading/loading.service';

@Injectable({
  providedIn: 'root',
})

export class TokenInterceptor implements HttpInterceptor {

  private token: string | null = null;
  private lang: string | null = null;


  constructor(private loadingService: LoadingService, private router: Router, private alertService: AlertService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.token = localStorage.getItem('accessToken');
    this.lang = localStorage.getItem('userLang');

    request = request.clone({
      setHeaders: {
        'Authorization': `${this.token ? this.token : ''}`,
        'Access-Control-Allow-Origin': '*',
        'Ocp-Apim-Subscription-Key': environment.OcpApimSubscriptionKey,
        'Language': this.lang ? this.lang : environment.defaultLang,
        'Cache-Control': 'max-age=31536000'
      }
    });

    if (request.url.includes(environment.apiUrl)) {
      this.loadingService.setLoading(true, request.url);
      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error && error.status === 401) {
            // 401 errors are most likely going to be because we have an expired token that we need to refresh.
            localStorage.removeItem('accessToken');
            window.open(environment.production ?  `${environment.FE_URL}/login?redirectURL=${environment.FE_URL}` :
                                                  `${environment.FE_URL}/login?redirectURL=${environment.FE_URL}`, '_self');

            return throwError(error);
          } else {
            // alertHandling
            if (error instanceof HttpErrorResponse) {
              if (error.status === 500 || error.status === 502 || error.status === 503) {
                this.alertService.error(error.error ? error.error.errorMessage ? error.error.errorMessage : '!Technical Error!' : '!Technical Error!');
              } else if (error.status === 400) {
                this.alertService.warning(error.error ? error.error.errorMessage ? error.error.errorMessage : '!BAD REQUEST!' : '!BAD REQUEST!');
              } else if (error.status === 404) {
                this.alertService.error(error.error ? error.error.errorMessage ? error.error.errorMessage : '!METHOD NOT FOUND!' : '!METHOD NOT FOUND!');
              } else if (error.status === 415) {
                this.alertService.error(error.error ? error.error.errorMessage ? error.error.errorMessage : 'Unsupported Media Type' : 'Unsupported Media Type');
              } else {
                this.alertService.error(error.error ? error.error.errorMessage ? error.error.errorMessage : '!SYSTEM ERROR!' : '!SYSTEM ERROR!');
              }
            }

            return throwError(error);
          }
        }),
        finalize(() => this.loadingService.setLoading(false, request.url))
      );
    } else {
      return next.handle(request);
    }
  }
}
